import * as React from 'react';

// Utils
import { getSupplierNameByCode } from '@src/shared/src/util/app';
// Constants
// Actions
// Models
import { OptionModel } from '@src/shared/src/models';
// Interfaces
// Components

import { CheckboxFilter } from './CheckboxFilter';
import { SidebarSection } from '@toolkit/ui';
// Styles

type Props = {
  title: string;
  suppliers: OptionModel[];
  isOpen?: boolean;
  onChange: (vehicles: OptionModel[]) => void;
};

const SupplierFilter: React.FC<Props> = ({ title, suppliers, isOpen, onChange }) => {
  const sortedSuppliers = suppliers
    .map((supplier) => ({ supplier, name: getSupplierNameByCode(supplier.label) }))
    .sort((a, b) => a.name.localeCompare(b.name));

  return (
    <SidebarSection title={title} isOpen={isOpen}>
      {sortedSuppliers.map(({ supplier, name }) => (
        <CheckboxFilter
          id={`su-id-${supplier.label}`}
          key={`su-key-${supplier.label}`}
          label={name}
          isChecked={Boolean(supplier.value)}
          onChange={(val) => {
            const nSuppliers: any = suppliers.map((sup: OptionModel) =>
              sup.label === supplier.label
                ? {
                    label: sup.label,
                    value: val,
                  }
                : sup,
            );
            onChange(nSuppliers);
          }}
          onChangeOnly={() => {
            const nSuppliers: any = suppliers.map((sup: OptionModel) =>
              sup.label === supplier.label
                ? { label: sup.label, value: true }
                : { label: sup.label, value: false },
            );
            onChange(nSuppliers);
          }}
        />
      ))}
    </SidebarSection>
  );
};

export default SupplierFilter;
